module.exports = __webpack_public_path__ + "static/media/pricing_tool_banner_deep-768x346.3c4a6214.jpg";